class MobileNavToggle extends HTMLElement {
	constructor() {
		super()
		this.menuDrawer = document.querySelector('.f-drawer-mobile-nav')
		this.addEventListener('click', this.openNav.bind(this))

		if (this.menuDrawer) {
			this.menuDrawer.addEventListener('close', () => {
				this.setAttribute('aria-expanded', 'false')
			})
		}
	}

	disconnectedCallback() {
		this.removeEventListener('click', this.openNav.bind(this))
	}

	openNav() {
		if (this.menuDrawer) {
			this.menuDrawer.openDrawer()
			this.setAttribute('aria-expanded', 'true')
		}
	}
}
customElements.define('mobile-nav-toggle', MobileNavToggle)

/* 3NODE - mobile menu - START */

// Position mobile menu under header
const header = document.querySelector(".site-header");
const mobileNav = document.querySelector(".f-drawer-mobile-nav");
const announcementBar = document.querySelector(".announcement-bar");

function updateMobileNavPosition() {
  const mediaQuery = window.matchMedia('(max-width: 768px)');

  const headerHeight = header.offsetHeight;
  const headerRect = header.getBoundingClientRect();
  
  const visibleHeaderHeight = Math.max(0, Math.min(headerHeight, window.innerHeight - headerRect.top));

  const newTopPosition = headerRect.top + visibleHeaderHeight - 1;

  mobileNav.style.top = `${newTopPosition}px`;
  mobileNav.style.height = `${window.innerHeight - newTopPosition}px`;
  mobileNav.style.position = 'fixed';
  mobileNav.style.overflowY = 'auto';
}

function throttle(func, limit) {
  let inThrottle;
  return function() {
    const args = arguments;
    const context = this;
    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  }
}

const throttledUpdateMobileNavPosition = throttle(updateMobileNavPosition, 16);

updateMobileNavPosition();

window.addEventListener("resize", throttledUpdateMobileNavPosition);
window.addEventListener("scroll", throttledUpdateMobileNavPosition);

const observerHeader = new MutationObserver((mutations) => {
  throttledUpdateMobileNavPosition();
});

observerHeader.observe(header, { 
  attributes: true, 
  childList: true, 
  subtree: true,
  characterData: true
});

const observerBody = new MutationObserver((mutations) => {
  throttledUpdateMobileNavPosition();
});

observerBody.observe(document.body, { 
  childList: true, 
  subtree: false
});

const observerMobileNav = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
        if (mutation.type === "attributes" && mutation.attributeName === "open") {
            updateMobileNavPosition();
        }
    }
});

observerMobileNav.observe(mobileNav, { attributes: true });

// Move announcement bar to mobile nav
const mobileNavAddons = document.querySelector('.f-mobile-nav__addons');
const originalParent = announcementBar.parentElement;

function updateAnnouncementBarPosition() {
    if (window.matchMedia('(max-width: 768px)').matches) {
        if (announcementBar.parentElement !== mobileNavAddons) {
            mobileNavAddons.appendChild(announcementBar);
            announcementBar.style.setProperty('display', 'flex', 'important');
        }
    } else {
        if (announcementBar.parentElement !== originalParent) {
            originalParent.appendChild(announcementBar);
        }
    }
}

updateAnnouncementBarPosition();

window.addEventListener('resize', updateAnnouncementBarPosition);

const observerAnnouncementBar = new MutationObserver(() => {
    updateAnnouncementBarPosition();
});

observerAnnouncementBar.observe(document.body, { childList: true, subtree: true });

// Close mobile menu
const closeButtons = document.querySelectorAll('.f-drawer__close');

closeButtons.forEach(button => {
  button.addEventListener('click', () => {
    const drawer = document.querySelector('.f-drawer-mobile-nav');
    
    if (drawer && drawer.hasAttribute('open')) {
      drawer.removeAttribute('open');
      document.body.classList.remove("prevent-scroll");
    }
  });
});

// Toggle mobile menu icons
const hamburgerBtn = document.getElementById('DrawerOpen-Mobile-Nav');
const closeBtn = document.getElementById('DrawerClose-Mobile-Nav');

hamburgerBtn.addEventListener('click', () => {
  hamburgerBtn.style.display = 'none';
  closeBtn.style.display = 'flex';
});

closeBtn.addEventListener('click', () => {
  closeBtn.style.display = 'none';
  hamburgerBtn.style.display = 'flex';
});


// Hide and show submenu slide
const backToMenuButtons = document.querySelectorAll(".f-mobile-slide__title__button");
const mobileNavButtons = document.querySelectorAll(".f-mobile-nav__button");
const mobileSlideBar = document.querySelectorAll(".f-mobile-slide__bar");
const mobileNavSubitems = document.querySelectorAll(".f-mobile-nav__subitem");
const mobileSlide = document.querySelector(".f-mobile-slide");

mobileNavButtons.forEach(button => {
  button.addEventListener('click', (event) => {
    const clickedButtonId = event.currentTarget.id;

    mobileSlideBar.forEach(element => {
      const elementId = element.id;

      if (elementId === clickedButtonId) {
        mobileSlide.style.display = "block";

        setTimeout(() => {
          mobileSlide.classList.add("f-mobile-slide--active");
        }, 10);
      } else {
        element.style.display = "none";
      }
    });

    mobileNavSubitems.forEach(item => {
      if (item.classList.contains(clickedButtonId)) {
        item.style.display = "block";
      } else {
        item.style.display = "none";
      }
    });
  });
});


backToMenuButtons.forEach(button => {
  button.addEventListener("click", () => {
    mobileSlide.classList.remove("f-mobile-slide--active");

    mobileSlide.addEventListener('transitionend', () => {
      mobileSlide.style.display = "none";
      mobileSlideBar.forEach(element => {
        element.style.display = "flex";
      });
    }, { once: true });
  });
});

/* 3NODE - mobile menu - END */